import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import AppShell from './components/AppShell';
import Dashboard from './components/Dashboard';
import Predictions from './components/Predictions';
import LiveScores from './components/LiveScores';
import Performance from './components/Performance';
import Arbitrage from './components/Arbitrage';
import ValueBets from './components/ValueBets';
import Login from './components/Login';

function App() {
  const [authToken, setAuthToken] = useState(() => localStorage.getItem('auth_token'));

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    setAuthToken(null);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {!authToken ? (
        <Login onLogin={setAuthToken} />
      ) : (
        <Router>
          <AppShell onLogout={handleLogout}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/predictions" element={<Predictions />} />
              <Route path="/arbitrage" element={<Arbitrage />} />
              <Route path="/value" element={<ValueBets />} />
              <Route path="/livescores" element={<LiveScores />} />
              <Route path="/stats" element={<Performance />} />
              <Route path="/history" element={<Performance />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AppShell>
        </Router>
      )}
    </ThemeProvider>
  );
}

export default App;
